import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';
import { IMarketingRequest } from '../models/marketing-options.model';
import { loadMarketingOptions, loadMarketingOptionsSuccess, loadMarketingOptionsFailure } from '../actions/marketing-options.actions';

export const marketingOptionsFeatureKey = 'marketingOptions';

export interface MarketingOptionState {
  marketingOptionsRequest: IMarketingRequest;
  marketingOptionsResponse: string;
  marketingOptionsFailure: IGenericError<ErrorResponse>;
}

export const initialState: MarketingOptionState = {
  marketingOptionsRequest: undefined,
  marketingOptionsResponse: undefined,
  marketingOptionsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadMarketingOptions, (state, action) => ({
    ...state,
    marketingOptionsRequest: action.request,
    isLoading: true
  })),
  on(loadMarketingOptionsSuccess, (state, action) => ({
    ...state,
    marketingOptionsResponse: action.response,
    isLoading: false
  })),
  on(loadMarketingOptionsFailure, (state, action) => ({
    ...state,
    loadNewUserPasscodesFailure: action.error,
    isLoading: false
  }))
);

export const getMarketingOptionsRequest = (state: MarketingOptionState) => state.marketingOptionsRequest;
export const getMarketingOptionsFailure = (state: MarketingOptionState) => state.marketingOptionsFailure;
